// src/utils/fullscreen-message.ts

export const showFullscreenMessage = (
  content: HTMLElement,
) => {
  const main = document.body.querySelector("main")!;
  main.innerHTML = "";
  main.className = "fullscreen-message";
  main.appendChild(content);
};
